"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useErrorNotification = exports.ErrorNotification = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const IError_1 = require("../../error/IError");
const I18n_1 = require("../../i18n/I18n");
const Notification_1 = require("./Notification");
function ErrorNotification(_a) {
    var { children } = _a, props = tslib_1.__rest(_a, ["children"]);
    return jsx_runtime_1.jsx(Notification_1.Notification, Object.assign({}, props, { children: IError_1.printError(children) }), void 0);
}
exports.ErrorNotification = ErrorNotification;
function useErrorNotification(_a) {
    var { Component, title } = _a, props = tslib_1.__rest(_a, ["Component", "title"]);
    const [errorNotification, setErrorNotification] = react_1.useState(undefined);
    const { t } = I18n_1.useTranslation();
    if (!title) {
        title = t("An error has occured");
    }
    if (!Component) {
        Component = ErrorNotification;
    }
    return {
        errorNotification: errorNotification ? (jsx_runtime_1.jsx(Component, Object.assign({}, props, { title: title, onClose: () => setErrorNotification(undefined) }, { children: errorNotification }), void 0)) : undefined,
        setErrorNotification,
    };
}
exports.useErrorNotification = useErrorNotification;
//# sourceMappingURL=ErrorNotification.js.map